export const GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST';
export const GET_COMPANY_FAILURE = 'GET_COMPANY_FAILURE';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';

export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
export const UPDATE_COMPANY_FAILURE = 'UPDATE_COMPANY_FAILURE';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';

export const GET_COMPANIES_REQUEST = 'GET_COMPANIES_REQUEST';
export const GET_COMPANIES_FAILURE = 'GET_COMPANIES_FAILURE';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';

export const GET_TIMEZONES_REQUEST = 'GET_TIMEZONES_REQUEST';
export const GET_TIMEZONES_SUCCESS = 'GET_TIMEZONES_SUCCESS';
export const GET_TIMEZONES_FAILURE = 'GET_TIMEZONES_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/company/mutation-types.js